// import { locales, LOCALE_EN, LOCALE_HY, LOCALE_RU } from '../core/locales';

// export const translations = {};
// function loadTranslations(locale, importCallback) {
//   translations[locale] = translations[locale] || {};
//   if (typeof importCallback !== 'function') {
//     return { locale, content: translations[locale] };
//   }

//   return importCallback().then((importedModule) => {
//     translations[locale] = JSON.parse(JSON.stringify(importedModule.default));
//     return { locale, content: translations[locale] };
//   });
// }

// export function loadAllTranslations() {
//   const promises = [
//     loadTranslations(LOCALE_EN, () => import('./messages/locales-en.json')),
//     loadTranslations(LOCALE_HY, () => import('./messages/locales-hy.json')),
//     loadTranslations(LOCALE_RU, () => import('./messages/locales-ru.json')),
//   ];

//   return Promise.all(promises).then((results) => {
//     return locales.reduce((acc, locale) => {
//       acc[locale] = results.find((result) => result.locale === locale).content;
//       return acc;
//     }, {});
//   });
// }

import { LOCALE_EN, LOCALE_HY, LOCALE_RU, LOCALE_UZ } from '../core/locales';
import localeEn from './messages/locales-en.json';
import localeHy from './messages/locales-hy.json';
import localeRu from './messages/locales-ru.json';
import localeUz from './messages/locales-uz.json';

export const translations = {
  [LOCALE_EN]: localeEn,
  [LOCALE_HY]: localeHy,
  [LOCALE_RU]: localeRu,
  [LOCALE_UZ]: localeUz,
};

export function loadAllTranslations() {
  return new Promise((resolve) => resolve(translations));
}
